// import React, { useEffect, useState }  from "react";
// import ReactHtmlParser from 'html-react-parser';
// // import parse from 'html-react-parser';
// import { Helmet } from 'react-helmet-async'; 
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { Url } from "../url/url";
 

// // ----------------------------------------------------------------------

// const ViewProduct = ()=>{
//     const productAllData = useSelector(store => store.product.data)  
//     const {id} = useParams()
//     const [productData, setProductData] = useState()


//     const editDataFilter = async()=>{
//         const dt = await productAllData.find(val => val._id === id)  
//         if(dt){ 
//             setProductData(dt) 
//         }
//     }

//     useEffect(()=>{
//         editDataFilter() 
//     }, [productAllData])
//   return (
//     <>
//       <Helmet>
//         <title> DooZieDo </title>
//       </Helmet>  
//       <h5 className="mb-3">{productData && productData.productName}</h5>
//       <div className="row">
//         <div className="col-lg-6 mb-3">
//           <div className="row">
//             <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
//               <div>
//                 <img src={`${productData && productData.thumbnailImage}`} alt="doozie-do" className="border rounded w-100 img-fluid" />
//               </div>
//             </div>
            
//               {productData && productData.images.map((cv, i)=>{
//                 return (
//                   <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-3" key={i}>
//                     <div>
//                     <img src={`${cv}`} alt="doozie-do" className="border rounded w-100 img-fluid" />
//                     </div>
//                   </div>
//                 )
//               })} 
//           </div>
//         </div>
//         <div className="col-lg-6 mb-3">
//           <p>{productData && productData.slug}</p>
//           <p>{productData && productData.shortDescription}</p>
//           <div className="mb-2">
//             <table className="table ">
//               <thead>
//                 <tr>
//                   <th>MRP</th>
//                   <th>Sale Price </th>
//                   <th>Discount (%)</th> 
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>{productData && productData.mrp}</td>
//                   <td>{productData && productData.salePrice}</td>
//                   <td>{productData && productData.discount}</td> 
//                 </tr>
//               </tbody>
//             </table> 
//           </div>
//           <p><span className="fw-bold">Category</span> :- <span>{productData && productData.category}</span></p> 
//           <p><span className="fw-bold">SubCategory</span> :- <span>{productData && productData.subcategory}</span></p> 
//           <p><span className="fw-bold">Total Product</span> :- <span>{productData && productData.totalProduct}</span></p> 
//           <p><span className="fw-bold">Product Size</span> :- <span>{productData && productData.productSize.height}</span> * <span>{productData && productData.productSize.height}</span> * <span>{productData && productData.productSize.height}</span> (<span>{productData && productData.productSize.measurement}</span>)</p> 
//           <p><span className="fw-bold">Replacement (Days)</span> :- <span>{productData && productData.replacement}</span></p> 
//           <p><span className="fw-bold">Batch No.</span> :- <span>{productData && productData.batch}</span></p> 
//           <p><span className="fw-bold">Sku No.</span> :- <span>{productData && productData.sku}</span></p> 


//         </div>
//       </div>
//       <h3>Description</h3>
//       <p>{productData && ReactHtmlParser(productData.description)}</p>
//       <h3>key features</h3>
//       <p>{productData &&  ReactHtmlParser(productData.keyFeature)}</p>
//       <h3>Specification</h3>
//       <p>{productData &&  ReactHtmlParser(productData.specification)}</p>
//       <h3>Other Info</h3>
//       <p>{productData && ReactHtmlParser(productData.otherInfo)}</p>
//     </>
//   );
// }

// export default  ViewProduct







import { useEffect, useState } from "react";
import ReactHtmlParser from 'html-react-parser';
import { Helmet } from 'react-helmet-async';
import { useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  Box, Container, Typography, Grid, Card, CardMedia, Chip,
  Divider, Stack, Avatar, Button
} from '@mui/material';
import Iconify from '../components/iconify';

const ViewProduct = () => {
  const productAllData = useSelector((store) => store.product.data);
  const { id } = useParams();
  const [productData, setProductData] = useState();

  useEffect(() => {
    const dt = productAllData.find((val) => val._id === id);
    if (dt) setProductData(dt);
  }, [productAllData, id]);

  if (!productData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Typography color="text.secondary">Loading product...</Typography>
      </Box>
    );
  }

  const allImages = [productData.thumbnailImage, ...(productData.images || [])];

  return (
    <>
      <Helmet><title>{productData.productName} | Admin</title></Helmet>

      <Container maxWidth="xl">

        {/* Back + Title */}
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 4 }}>
          <Button
            component={Link}
            to="/dashboard/products"
            startIcon={<Iconify icon="eva:arrow-back-fill" />}
            variant="outlined"
            size="small"
            sx={{ borderRadius: 2 }}
          >
            Back
          </Button>
          <Box>
            <Typography variant="h4" fontWeight={500}>{productData.productName}</Typography>
            <Typography variant="body2" color="text.secondary">{productData.slug}</Typography>
          </Box>
        </Stack>

        <Grid container spacing={3}>

          {/* Left — Images */}
          <Grid item xs={12} md={5}>
            <Card sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid', borderColor: 'divider', boxShadow: 'none', mb: 2 }}>
              <CardMedia
                component="img"
                image={productData.thumbnailImage}
                alt={productData.productName}
                sx={{ height: 320, objectFit: 'contain', bgcolor: 'background.neutral', p: 2 }}
              />
            </Card>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
              {productData.images?.map((img, i) => (
                <Avatar
                  key={i}
                  src={img}
                  variant="rounded"
                  sx={{ width: 72, height: 72, borderRadius: 2, border: '1px solid', borderColor: 'divider', cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
                />
              ))}
            </Box>
          </Grid>

          {/* Right — Details */}
          <Grid item xs={12} md={7}>
            <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', boxShadow: 'none', p: 3 }}>

              {/* Short Description */}
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
                {productData.shortDescription}
              </Typography>

              {/* Pricing Row */}
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 3, p: 2, bgcolor: 'background.neutral', borderRadius: 2 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">MRP</Typography>
                  <Typography variant="h6" fontWeight={500} sx={{ textDecoration: 'line-through', color: 'text.secondary' }}>
                    ₹{productData.mrp}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">Sale Price</Typography>
                  <Typography variant="h5" fontWeight={600} color="success.main">
                    ₹{productData.salePrice}
                  </Typography>
                </Box>
                <Chip
                  label={`${productData.discount}% OFF`}
                  color="error"
                  size="small"
                  sx={{ ml: 'auto', fontWeight: 600, borderRadius: 1.5 }}
                />
              </Box>

              <Divider sx={{ mb: 2.5 }} />

              {/* Info Grid */}
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                {[
                  { label: 'Category', value: productData.category, icon: 'eva:layers-fill' },
                  { label: 'SubCategory', value: productData.subCategory, icon: 'eva:list-fill' },
                  { label: 'Total Stock', value: productData.totalProduct, icon: 'eva:cube-fill' },
                  { label: 'Remaining', value: productData.remainingProduct, icon: 'eva:archive-fill' },
                  { label: 'SKU', value: productData.sku, icon: 'eva:hash-fill' },
                  { label: 'Batch No.', value: productData.batch, icon: 'eva:bookmark-fill' },
                  { label: 'Replacement', value: `${productData.replacement} days`, icon: 'eva:refresh-fill' },
                  { label: 'Weight', value: `${productData.weight}g`, icon: 'eva:activity-fill' },
                ].map((item) => (
                  <Box
                    key={item.label}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, bgcolor: 'background.neutral', borderRadius: 2 }}
                  >
                    <Box sx={{ width: 32, height: 32, borderRadius: 1.5, bgcolor: 'primary.lighter', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Iconify icon={item.icon} width={16} sx={{ color: 'primary.main' }} />
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary" display="block">{item.label}</Typography>
                      <Typography variant="body2" fontWeight={500} textTransform="capitalize">{item.value || '—'}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              {/* Product Size */}
              {productData.productSize && (
                <>
                  <Divider sx={{ my: 2.5 }} />
                  <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={0.8}>
                    Product Size
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
                    {[
                      { label: 'Height', value: productData.productSize.height },
                      { label: 'Width', value: productData.productSize.width },
                      { label: 'Depth', value: productData.productSize.depth },
                    ].map((s) => (
                      <Box key={s.label} sx={{ textAlign: 'center', p: 1.5, bgcolor: 'background.neutral', borderRadius: 2, flex: 1 }}>
                        <Typography variant="h6" fontWeight={500}>{s.value || '—'}</Typography>
                        <Typography variant="caption" color="text.secondary">{s.label} ({productData.productSize.measurement})</Typography>
                      </Box>
                    ))}
                  </Box>
                </>
              )}

              {/* Tags */}
              {productData.tags && (
                <>
                  <Divider sx={{ my: 2.5 }} />
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={0.8}>
                      Tag:
                    </Typography>
                    <Chip label={productData.tags} size="small" color="warning" sx={{ textTransform: 'capitalize', borderRadius: 1.5 }} />
                  </Stack>
                </>
              )}
            </Card>
          </Grid>

          {/* Bottom — HTML Sections */}
          {[
            { title: 'Description', content: productData.description, icon: 'eva:file-text-fill' },
            { title: 'Key Features', content: productData.keyFeature, icon: 'eva:star-fill' },
            { title: 'Specification', content: productData.specification, icon: 'eva:list-fill' },
            { title: 'Other Info', content: productData.otherInfo, icon: 'eva:info-fill' },
          ].map((section) => section.content && (
            <Grid item xs={12} md={6} key={section.title}>
              <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', boxShadow: 'none', p: 3, height: '100%' }}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                  <Box sx={{ width: 32, height: 32, borderRadius: 1.5, bgcolor: 'primary.lighter', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Iconify icon={section.icon} width={16} sx={{ color: 'primary.main' }} />
                  </Box>
                  <Typography variant="subtitle1" fontWeight={600}>{section.title}</Typography>
                </Stack>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ fontSize: 14, color: 'text.secondary', lineHeight: 1.8, '& p': { margin: 0 } }}>
                  {ReactHtmlParser(section.content)}
                </Box>
              </Card>
            </Grid>
          ))}

        </Grid>
      </Container>
    </>
  );
};

export default ViewProduct;